export default __webpack_public_path__ + "static/media/66-NduduzoShabalala.5912ec60.jpg";